import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import IconButton from '../../IconButton';
import CheckIcon from '../../../../public/assets/images/theme-2/icons/handin-hover.svg';
import {
  PreviewSection,
  SubmitPanel,
  Glossary,
  GlossaryHeader,
  GlossaryBody,
  GlossaryRow,
  GlossaryConcept,
  GlossaryDescription,
} from '../styles';
import { PreviewText } from '../../NodeActivityEditor/styles';

const GlossaryContentPreview = ({ data, previewText, embedded = false }) => {
  const [concepts, setConcepts] = useState([]);

  useEffect(() => {
    const list = data?.CorrelationList;
    const newConcepts = list?.Concepts || list?.CorrelationConcepts || [];
    setConcepts(newConcepts);
  }, [data]);

  return (
    <>
      <PreviewSection embedded={embedded}>
        <Glossary>
          <GlossaryHeader>
            <GlossaryConcept>{i18n.__('correlation_term')}</GlossaryConcept>
            <GlossaryDescription>{i18n.__('correlation_description')}</GlossaryDescription>
          </GlossaryHeader>
          <GlossaryBody>
            {concepts.map((concept, index) => {
              const description = concept.Description || concept.CorrelationDescription;
              return (
                <GlossaryRow key={concept.id} even={index % 2}>
                  <GlossaryConcept dangerouslySetInnerHTML={{ __html: concept.body }} />
                  <GlossaryDescription dangerouslySetInnerHTML={{ __html: description.body }} />
                </GlossaryRow>
              );
            })}
          </GlossaryBody>
        </Glossary>
        {previewText && <PreviewText dangerouslySetInnerHTML={{ __html: previewText }} />}
      </PreviewSection>
      {!embedded && (
        <SubmitPanel className={'ir-hide'}>
          <IconButton disabled={true} icon={CheckIcon}>
            {i18n.__('app_done')}
          </IconButton>
        </SubmitPanel>
      )}
    </>
  );
};

export default GlossaryContentPreview;

GlossaryContentPreview.propTypes = {
  data: PropTypes.object.isRequired,
  previewText: PropTypes.string,
  embedded: PropTypes.bool,
};
